<template>
  <div>
    <Banner/>
    <AcercaHome/>
    <PlanComercial/>
    <Videos/>
    <CursosHome/>
    <Testimonios/>
    <Clientes/>
    <Podcast/>
    <Libro/>
    <Newsletter/>
    <Instagram/>
    <Contacto/>
    <b-modal ref="libro" size="xl" centered hide-footer id="modalLibro">
      <b-row>
        <b-col cols="12" order="2" lg="6" order-lg="1" class="modalText">
            <h3><span>Cambias</span> o te cambian</h3>
            <p>por Hanniel Maldonado</p>
            <p class="text">Haz RESET y aprende los 11 fundamentos para dirigir a un equipo de ventas y hacerlo excepcionalmente bien.</p>
            <a href="https://amzn.to/2Tyd0iv" target="_blank" class="btn">adquiere tu libro en amazon</a>
        </b-col>
        <b-col cols="12" order="1" lg="6" order-lg="2">
            <img src="../assets/img/img_book.jpg" alt="Libro">
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import Banner from './Banner'
  import AcercaHome from './AcercaHome'
  import PlanComercial from './PlanComercial'
  import Videos from './Videos'
  import CursosHome from './CursosHome'
  import Testimonios from './Testimonios'
  import Clientes from './Clientes'
  import Podcast from './Podcast'
  import Libro from './Libro'
  import Newsletter from './Newsletter'
  import Instagram from './Instagram'
  import Contacto from './Contacto'

  export default {
    components: {
      Banner,
      AcercaHome,
      PlanComercial,
      Videos,
      CursosHome,
      Testimonios,
      Clientes,
      Podcast,
      Libro,
      Newsletter,
      Instagram,
      Contacto
    },
    metaInfo() {
        return { 
            meta: [
                { property: 'og:title', content: 'Hanniel Maldonado' },
                { property: 'og:site_name', content: 'Hanniel Maldonado' },
                { name: 'description', content:  'Mi preparación ha sido enfocada en áreas de Comercialización, Mercadotecnia y Negociación, lo que me ha permitido poder aplicar mejores prácticas y métodos de trabajo.'},
                { property: 'og:type', content: 'website'},   
                { property: 'og:url', content: 'https://hannielmaldonado.ddns.net/' }, 
                { property: 'og:image', content: 'https://hannielmaldonado.ddns.net/static/hanniel maldonado.jpg' }  
            ]
        }
    },
    mounted() {
      this.$refs['libro'].show();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue